import React from 'react';

export const CategoryManagementContext = React.createContext({});
